<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="dollar-sign"/>
          {{ $t('finance') }}
        </h1>
      </div>
    </div>
    <finance-list></finance-list>
  </main>
</template>

<script>
import FinanceList from './FinanceList';
export default {
  components: {FinanceList},
  i18n: {
    messages: {
      en: {
        finance: 'Finance Report',
      },
      vi: {
        finance: 'Báo cáo tài chính',
      }
    }
  }
}
</script>
